import React from "react";
import { DocumentArchieveItemProps } from "./DocumentArchieveItem.props";
import { P } from "common/P/P";
import { ReactComponent as ClipIcon } from "common/assets/icons/paperclip2.svg";

const DocumentArchieveItem: React.FC<DocumentArchieveItemProps> = ({
	name,
	quantity,
	date,
	onClick,
}) => {
	return (
		<div
			className="p-4 rounded-md cursor-pointer bg-white shadow-md grid grid-cols-1 gap-2 w-full min-w-[300px]"
			onClick={onClick}
		>
			<div className="grid grid-cols-1 gap-4">
				<div className="grid grid-cols-1">
					<P size="p3" type="medium" className="cursor-pointer text-mainColor">
						{name}
					</P>
				</div>
				<div className="grid grid-cols-maxTwo place-content-between place-items-center">
					<div className="grid gap-1 grid-cols-maxTwo place-items-center">
						<ClipIcon className="" />
						<P size="p3" type="regular" className="cursor-pointer text-grayTwo">
							{quantity}
						</P>
					</div>
					<P
						size="p3"
						type="regular"
						className="cursor-pointer text-passiveTextColor"
					>
						{date}
					</P>
				</div>
			</div>
		</div>
	);
};

export default DocumentArchieveItem;
